<template>
	<div>
		<nav class="nav-tabs">
			<ul>
				<li :class="[activeTabName === tab.name ? 'active ' + tab.name : tab.name]" v-for="tab in tabs" v-if="!tab.disabled">
					<span v-if="tab.disabled"><i :class="tab.icon"></i>{{ tab.displayName }}</span>
					<a @click.prevent="setActiveTabName(tab.name)" v-if="!tab.disabled">
						<i :class="tab.icon"></i> {{ tab.displayName }} &nbsp;
						<div class="badge badge-danger m-l-10" v-if="tab.badge">{{tab.badge}}</div>
					</a>
				</li>
			</ul>
		</nav>
		<provider-general :providerid="providerId" v-if="activeTabName === 'general'"></provider-general>
		<provider-properties-container :providerid="providerId" v-if="activeTabName === 'properties'"></provider-properties-container>
		<provider-commercial-container :providerid="providerId" v-if="activeTabName === 'commercial'"></provider-commercial-container>
		<provider-pricing-container :providerid="providerId" v-if="activeTabName === 'pricing'"></provider-pricing-container>
		<provider-in-articles-container :providerid="providerId" v-if="activeTabName === 'articles'"></provider-in-articles-container>
		<provider-change-request-container :providerid="providerId" v-if="activeTabName === 'change_requests'"></provider-change-request-container>
	</div>
</template>

<script>
	export default {
		props: {
			providerid: {
				type: Number
			}
		},
		data() {
			return {
				tabName: 'main',
				currentDate: this.dataCurrentDate,
				providerId: this.providerid,
				changeRequests: [],

				tabs: [
					{
						name: 'general',
						displayName: 'General',
						icon: 'fas fa-home',
						disabled: false
					},
					{
						name: 'properties',
						displayName: 'Properties',
						icon: 'fas fa-sliders-h',
						disabled: false
					},
					{
						name: 'commercial',
						displayName: 'Commercial',
						icon: 'far fa-money-bill-alt',
						disabled: false
					},
					{
						name: 'pricing',
						displayName: 'Pricing',
						icon: 'fas fa-money-bill',
						disabled: false
					},
					{
						name: 'articles',
						displayName: 'Articles',
						icon: 'fas fa-newspaper',
						disabled: false
					},
					{
						name: 'change_requests',
						displayName: 'Change Requests',
						icon: 'fas fa-question-circle',
						disabled: false
					},
				],
				activeTabName: null,
			}
		},
		created() {
			this.fetchDataFromApi();
			let url_string = window.location.href;
			let url = new URL(url_string);
			this.activeTabName = url.searchParams.get("tab");
		},
		mounted() {
			// TODO refactor this!!!!
			this.activeTabName = this.activeTabName ? this.activeTabName : this.tabs[0].name;
		},
		methods: {
			fetchDataFromApi: function () {
				let vm = this;
				axios.post('/api/' + vm.$selectedSite.slug + '/providers/fetchtabdata/' + vm.providerId, {
					tab: vm.tabName
				})
					.then(response => {
						if (response.data.hasOwnProperty('generalProviderData')) {
							vm.changeRequests = response.data.changeRequests;
							vm.$set(vm.tabs[5], 'badge', vm.changeRequests.length);

						}
						vm.loaded = true;
					})
					.catch(e => {
						vm.$toastr.error('Api ' + vm.tabName + ' tab load failed', 'Error');
					});
			},
			setActiveTabName: function (name) {
				this.activeTabName = name;
				window.history.replaceState('', '', this.updateURLParameter(window.location.href, 'tab', name));
			},
			updateURLParameter: function (url, param, paramVal) {
				let newAdditionalURL = "";
				let tempArray = url.split("?");
				let baseURL = tempArray[0];
				let additionalURL = tempArray[1];
				let temp = "";
				if (additionalURL) {
					tempArray = additionalURL.split("&");
					for (var i = 0; i < tempArray.length; i++) {
						if (tempArray[i].split('=')[0] != param) {
							newAdditionalURL += temp + tempArray[i];
							temp = "&";
						}
					}
				}

				let rows_txt = temp + "" + param + "=" + paramVal;
				return baseURL + "?" + newAdditionalURL + rows_txt;
			},
		},
	}
</script>

<style scoped>

</style>
